import { tw } from "./utils";

export const Divider = tw.div`h-px w-full bg-app-divider`;

export const VerticalDivider = tw.div`h-full w-px bg-app-divider`;
